// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"353cb767","455":"81a75041","611":"73400be0"}[chunkId] + ".chunk.js";
};